module.exports = __webpack_public_path__ + "img/bingo-tarjetas-silabas-inversas.1282df47.png";